
<div mat-dialog-title>
	<fa-icon icon="times" (click)="onClick()" class="fdm-icon float-right" style="cursor:pointer;color:#555;margin-top:-20px;margin-right:-14px;"></fa-icon>
	{{data.title | translate : { name: data.dataset.name} }}
</div>

<div *ngIf="loading">
    <div class="loading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
</div>
<div mat-dialog-content>

	<div class="row">
		<div class="col-9">
			<div style="max-height:640px !important">
				<map-viewer name="dialog"></map-viewer>
			</div>
			
			<button class="full-width mt-2" mat-fab (click)="foucs()"><fa-icon icon="crosshairs"></fa-icon></button>
		</div>
    <div class="col-3"  *ngIf="transform && transform.transformType.uid == 'three-d-tiles'">

			<ng-container *ngIf="inputType == 'laslaz' || inputType == 'laslaz-tiles'">
				<div qmap-question [qMap]="{type:'json',title:'DIALOG.PC_OPTIONS' | translate, id:'pointCloudShading'}" (qmap-change)="voff()" [model]="transform"></div>
			</ng-container>

			<ng-container *ngIf="inputType == 'terrain/tiff'">
				<div qmap-question [qMap]="{type:'json',title:'DIALOG.TERRAIN_OPTIONS' | translate, id:'pointCloudShading'}" (qmap-change)="voff()" [model]="transform"></div>
        <div qmap-question [qMap]="{type:'boolean',title:'DIALOG.USE_SHADING' | translate, id:'shading'}" (qmap-change)="voff()" [model]="transform"></div>
			</ng-container>

			<mat-form-field class="full-width">
        <input placeholder=" {{ 'DIALOG.SCREEN_ERROR' | translate }}" matInput type="number" [(ngModel)]="transform.maximumScreenSpaceError" (change)="voff()"/>
			</mat-form-field>&nbsp;

		    <ng-container *ngIf="inputType != 'laslaz' && inputType != 'laslaz-tiles'">
				<!--<mat-form-field class="full-width"><input placeholder="Rotate Heading" matInput type="number" [(ngModel)]="rot_head" (change)="adjustPoint()"/>
				</mat-form-field>
				<mat-form-field class="full-width"><input placeholder="Rotate Pitch" matInput type="number" [(ngModel)]="rot_pitch" (change)="adjustPoint()"/>
				</mat-form-field>

				<mat-form-field class="full-width"><input placeholder="Rotate Roll" matInput type="number" [(ngModel)]="rot_roll" (change)="adjustPoint()"/>
				</mat-form-field>




				<button class="full-width mt-2" [color]="repick?'primary':''" mat-raised-button (click)="repick = !repick">Pick Position</button>-->
			    <button *ngIf="transform.matrix" class="full-width mt-2" color="warn" mat-raised-button (click)="transform.matrix = null;voff()">{{ 'DIALOG.CLEAR_TRANSFORM' | translate }}</button>
			</ng-container>

			<mat-form-field class="full-width">
        <input placeholder="{{ 'DIALOG.VERTICAL_OFFSET' | translate }}" matInput type="number" [(ngModel)]="transform.vertical_offset" (input)="useHeight()" />
    </mat-form-field>

    <mat-checkbox class="full-width mt-2" color="primary" mat-raised-button [(ngModel)]="transform['clipGlobe']" (change)="mapService.clipGlobe($event.checked, this.transform);">{{ 'DIALOG.CLIP_GLOBE' | translate }}</mat-checkbox>

			<button  class="full-width mt-2" color="success" mat-raised-button (click)="transform.saveObservable().subscribe();mapService.currentProject = null"> {{ 'GENERIC.SAVE' | translate }}</button>
		</div>
    <div class="col-3"  *ngIf="transform && (transform.transformType.uid == 'kml' || transform.transformType.uid ==  'geo-json')">
        <input type="color" value="#ff0000" class="full-width mt-2" placeholder="{{ 'DIALOG.COLOR' | translate }}"  (change)="setCurrentColor($event)" [(ngModel)]="currentColor"  name="color" /> <br><br>

    <button  class="full-width mt-2" color="success" mat-raised-button (click)="transform.saveObservable().subscribe();mapService.currentProject = null">{{ 'GENERIC.SAVE' | translate }}</button>
    </div>
	</div>
</div>

<div mat-dialog-actions class="align-content-right">
    <button *ngIf="data.negBtn" color="primary" mat-button (click)="onClick(false)" translate>{{data.negBtn | translate }}</button>
    <button color="primary" mat-button (click)="onClick()" >{{(data.posBtn ? data.posBtn : "GENERIC.OK") | translate }}</button>
</div>
